// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ChartPointAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import { observer } from 'mobx-react';
import React from 'react';
import ChartDataParser from 'share/utils/Izenda.ChartDataParser';
import { isUndefined, get, isNil } from 'lodash/fp';
import HighchartUtils from 'share/components/charting/highcharts/Izenda.HighchartUtils';
import ReportPartUtils from 'share/utils/Izenda.ReportPartUtils';
export default observer(function ChartPointAction(props: any) {
  const getLabel = (value: object): any => {
    return isUndefined(value)
      ? { fomattedValue: '' }
      : ChartDataParser.getValueStyle(value, configField, props.fieldSource) || {};
  };

  const pointAction = (formattedValue: string): void => {
    const { pointAction, linkTo, fieldName } = props;
    const separator = linkTo
      ? {
          separatorColumnName: get('groupField.columnName', linkTo),
          separatorValue: get('groupName', linkTo)
        }
      : null;

    pointAction &&
      pointAction(
        configField,
        [
          {
            key: fieldName,
            value: formattedValue
          }
        ],
        separator
      );
  };

  const { configField = {}, value, fieldSource } = props;
  const { numberOfPointActions } = configField;
  const record = get('record', fieldSource);
  const fieldElement = get('element', fieldSource);
  let originalValue;
  if (!isNil(record)) {
    originalValue = ReportPartUtils.getOriginalValue(fieldElement, record);
  }

  const valueFormatedByFormatString = HighchartUtils.getFormatedValueByStringFormat(
    configField.fieldElement, value
  );

  const formattedName = getLabel({
    value: !isNil(valueFormatedByFormatString) ? valueFormatedByFormatString : value,
    originalValue: originalValue
  });

  return numberOfPointActions > 0 ? (
    <a
      className="overflow-text u_textLink"
      style={formattedName.style}
      onClick={pointAction.bind(this, formattedName.valueWithoutAltText)}
    >
      {formattedName.fomattedValue}
    </a>
  ) : (
    <span className="overflow-text" style={formattedName.style}>
      {formattedName.fomattedValue}
    </span>
  );
});



// WEBPACK FOOTER //
// ./ui/share/components/charting/Izenda.ChartPointAction.js